/**
 * @module cercaliagl/control/Logo
 */
import Control from './Control';
import MapControls from './MapControls';

/**
 * @classdesc
 * Class for internal purposes. It shows map attributions.
 * @constructor
 * @extends {Control}
 * @api
 */
class Logo extends Control {
  constructor() {
    const element = document.createElement('div');

    super({
      element,
      className: 'cercaliagl.control.Logo',
      name: MapControls.LOGO,
    });

    const year = new Date().getFullYear();

    /**
     * @private
     * @const
     * @type {string}
     */
    this.DEFAULT_CONTENT_ = `
     <div class="static">
       <span>Cercalia - Data: </span>
       <a href="https://www.cercalia.com" target="_blank">Cercalia, </a>
       <a href="https://www.tomtom.com" target="_blank">TomTom, </a>
       <a href="https://www.openstreetmap.org" target="_blank">OpenStreetMap, </a>
       <a href="https://www.openmaptiles.org" target="_blank">OpenMapTiles, </a>
       <a href="https://www.naturalearthdata.com" target="_blank">Natural Earth</a>
       <a href="https://www.rainviewer.com/api.html" target="_blank">Rain Viewer</a>
       <span>- ${year}</span>
     </div>
     <div class="custom"></div>
    `;

    /**
     * @private
     * @type {Element}
     */
    this.element_ = element;
    this.element_.className = 'cercalia-logo';
    this.element_.innerHTML = this.DEFAULT_CONTENT_;
  }

  /**
   * Change attribution content
   * @param {string} content Content in HTML string
   * @api
   */
  setAttribution(content) {
    this.element_.querySelector('.custom').innerHTML = content;
  }

  /**
   * @api
   */
  restoreDefault() {
    this.element_.innerHTML = this.DEFAULT_CONTENT_;
  }
}

export default Logo;
